import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import SavingsIcon from "@mui/icons-material/AttachMoney";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";

const features = [
  {
    icon: <SavingsIcon fontSize="large" />,
    title: "Bundle and Save",
    description: "Get 2 or more boxes and save 10%.",
  },
  {
    icon: <LocalShippingIcon fontSize="large" />,
    title: "Local Delivery Available",
    description: "We offer delivery within St. John's and nearby cities.",
  },
  {
    icon: <CardGiftcardIcon fontSize="large" />,
    title: "Gift Packaging",
    description: "Add special packaging to make it the perfect gift!",
  },
];

const FeatureHighlightsStrip = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#121212",
        color: "#fff",
        py: 6,
        px: { xs: 2, sm: 4 },
        textAlign: "center",
      }}>
      <Grid container spacing={4} justifyContent="center">
        {features.map((feature, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Box>
              {feature.icon}
              <Typography variant="h6" sx={{ mt: 2, fontWeight: "bold" }}>
                {feature.title}
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                {feature.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeatureHighlightsStrip;
